const domainName = `https://safetrainings.api.american-technology.net`;
// const domainName = `https://safetrainings-automation.api.american-technology.net`;
export default {
  list: `${domainName}/api/trainings/getActiveTrainings`,
  detail: `${domainName}/api/trainings/?id=`,
  coupon: `${domainName}/api/trainings/coupon`,
  enroll: `${domainName}/api/trainings/enrollTrainee`,
  paymentError: `${domainName}/api/trainings/payment/failed`,
  paymentStarted: `${domainName}/api/trainings/payment/started`,
  filterList: `${domainName}/api/trainings/getMasterData`,
  stripePayment: `${domainName}/api/trainings/stripepayment`,
  hasAlreadyEnrolled: `${domainName}/api/trainings/hasAlreadyEnrolled`,
};
